import getConfig from './configProvider';

export default {
  install(Vue) {
     // eslint-disable-next-line no-multi-assign
    Vue.prototype.$appsettings = Vue.$appsettings = getConfig();
  }
};



// WEBPACK FOOTER //
// ./src/components/plugins/AppConfig/index.js